<template>
    <div class="container">
        <!--<common-top-form :model="formModel" :show="false" :submitService="submitService"-->
                         <!--:submitData="submitData" @success="onSuccess">-->
                <!--<select-organs v-model="formModel.tatSimpleId"></select-organs>-->
                <!--<el-form-item label="会员名称">-->
                    <!--<el-input type="text" maxlength="20" v-model="formModel.memName" placeholder="请输入会员名称"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="会员电话">-->
                    <!--<el-input type="text" maxlength="20" v-model="formModel.memPhone" placeholder="请输入会员电话"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="卡号">-->
                    <!--<el-input type="text" maxlength="50" v-model="formModel.cardNo" placeholder="请输入卡号"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="卡类型">-->
                    <!--<el-select v-model="formModel.cardType">-->
                        <!--<el-option-->
                            <!--v-for="item in cardTypes"-->
                            <!--:key="item.id"-->
                            <!--:label="item.label"-->
                            <!--:value="item.label">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
            <!--<el-form-item label="应答状态">-->
                <!--<el-select v-model="formModel.respCode">-->
                    <!--<el-option-->
                        <!--v-for="item in authStatus"-->
                        <!--:key="item.dictKey"-->
                        <!--:label="item.dictValue"-->
                        <!--:value="item.dictKey">-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
                <!--<el-form-item label="发送时间">-->
                    <!--<el-date-picker-->
                        <!--v-model="time"-->
                        <!--type="daterange"-->
                        <!--range-separator="至"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--start-placeholder="开始日期"-->
                        <!--end-placeholder="结束日期">-->
                    <!--</el-date-picker>-->
                <!--</el-form-item>-->
        <!--</common-top-form>-->
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="orderNo" label="订单号" min-width="300" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="cardNo" label="卡号" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{doUnicode(scope.row.cardNo)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="cardType" label="卡类型" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="userName" label="姓名" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="userPhone" label="电话" min-width="130" :formatter="formatterTableData">
                <!--<template slot-scope="scope">-->
                <!--<p>{{doUnicode(scope.row.userPhone)}}</p>-->
                <!--</template>-->
            </el-table-column>
            <el-table-column prop="idCard" label="身份证号" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{doUnicode(scope.row.idCard)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="认证状态" min-width="100" show-overflow-tooltip  :formatter="formatterTableStatus"></el-table-column>
            <el-table-column prop="chnName" label="认证通道" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="reqTime" label="请求时间" min-width="160" :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="respTime" label="响应时间" min-width="160" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="respMsg" label="响应内容" min-width="160" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'

    import CardTypes from 'service/constant/CardTypes'
    import OrganService from 'service/OrganService'
    import TransactionService from 'service/TransactionService'
    import TimeRange from 'service/constant/TimeRange'
    import AuthStatus from 'service/constant/AuthStatus'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "certification",
        components: {
            CommonTopForm, CommonTable, SelectOrgans
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    cardNo: '',
                    memName: '',
                    memPhone: '',
                    respCode: '',
                    cardType: '全部',
                },
                authStatus: AuthStatus,
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                cardTypes: CardTypes,
                tableData: [],
                time: TimeRange.dayRange,
                page: {},
                isPage: false,
                submitService: TransactionService.getRauths
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed: {
            submitData() {
                if (this.time == null || this.time == '') {
                    this.time = [];
                }
                const params = {
                    userId: this.userId,
                    tatSimpleId: this.formModel.tatSimpleId,
                    cardNo: this.formModel.cardNo,
                    status: this.formModel.respCode,
                    memName: this.formModel.memName.trim(),
                    memPhone: this.formModel.memPhone.trim(),
                    cardType: this.formModel.cardType.trim(),
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.time.length) {
                    params.startDate = this.time[0];
                    params.endDate = this.time[1];
                }

                if (this.formModel.cardType == '全部') {
                    delete params.cardType;
                }

                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        methods: {
            formatterTableStatus(row, column, cellValue, index){
                let value = '--';
                this.authStatus.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue
                    }
                });
                return value;
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, {
                    userId: this.$route.params.id,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                }, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.records;

                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/Certification.vue